<template>
<div>
  <v-card>
  <v-data-table
    :headers="headers"
    :items="completedList"
    :options.sync="options"
    :server-items-length="totalCount"
    :loading="loading"
    :footer-props="footerProps"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
      flat dense>
      <h2 class="mei-title mt-5 mb-1">Completed Requests</h2>
      </v-toolbar>
      <v-toolbar
        flat
      >
        <v-text-field
        v-model="searchText"
        append-icon="mdi-magnify"
        label="Search"
        color="green darken-2"
        single-line
        hide-details
      ></v-text-field>
        <v-spacer></v-spacer>
          <vue-json-to-csv 
          :json-data="itemListForCSV"
          :labels="{ 
            RequestCode: { title: 'Request Code' },
            RequestType: { title: 'Request Type' },
            DateCreated: { title: 'Date Created' },
            DateApproved: { title: 'Date Approved' },
            DateCompeleted: { title: 'Date Completed' },
            DateCreated: { title: 'Date Created' },
            }"
          csv-title="Completed Requests">
            <v-btn
              outlined
              color="green darken-2"
              dark
              :loading="loadingCSV"
            >
              <v-icon class="mr-1">mdi-microsoft-excel</v-icon>
              CSV
            </v-btn>
          </vue-json-to-csv>
      </v-toolbar>
    </template>
      <template v-slot:[`item.DateCreated`]="{ item }">
          {{formatDateTime(item.DateCreated)}}
      </template>
      <template v-slot:[`item.DateApproved`]="{ item }">
          {{formatDateTime(item.DateApproved)}}
      </template>
      <template v-slot:[`item.DateCompleted`]="{ item }">
          {{formatDateTime(item.DateCompleted)}}
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <span class="text-no-wrap">
          <v-btn color="blue darken-2" class="white--text mr-2" outlined x-small @click="viewItem(item)">
          view
          </v-btn>
          <v-btn color="red darken-2" class="white--text" outlined x-small @click="print(item)">
          Print
          </v-btn>
        </span>
      </template>
  </v-data-table>
   </v-card>
   <ViewRequest :requestData="viewData" />
      <fade-away-message-component
			displayType="variation2"
			v-model="fadeAwayMessage.show" 
			:message="fadeAwayMessage.message" 
			:header="fadeAwayMessage.header" 
			:top="fadeAwayMessage.top"
			:type="fadeAwayMessage.type"
		></fade-away-message-component>
  </div>
</template>

<script>
import ViewRequest from './ViewRequest.vue'

  export default {
    components: {
      ViewRequest
    },
    props: {
      fiscalYear: null,
    },
    data: () => ({
      searchText: "",
      searchTimeout : null,
      amountErr: null,
      amountErr2: null,
      editItemId: null,
       footerProps: {'items-per-page-options': [5, 10, 20, 50, 100, 500]},
      totalCount: 0,
      loading: true,
       options: {},
      fadeAwayMessage : {
			show : false,
			type : 'success',
			header : 'Successfully Saved!',
			message : '',
			top : 10
		},
      isLoading: false,
      menu: false,
      menu1: false,
      formData: {
         BudgetID: null,
         PerBudgetRecord: null,
         Remarks: null,
      },
      addBudgetDialog: false,
      completedList: [],
      headers: [
        { text: 'Request Code', value: 'RequestCode', sortable: false, align: 'start', class: "green darken-2 white--text text-caption font-weight-bold" },
        {
          text: 'RequestType',
          align: 'start',
          sortable: false,
          value: 'RequestType',
          class: "green darken-2 white--text text-caption font-weight-bold",
        },
        // { text: 'Office', value: 'Office', align: "start", sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        // { text: 'Requested By', value: 'RequestedBy', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Date Created', value: 'DateCreated', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Date Completed', value: 'DateCompleted', align: 'center', sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
        { text: 'Actions', value: 'Actions', align: "center", sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" }
      ],
      itemListForCSV: [],
      loadingCSV: true,
      viewData: [],
    }),
    watch: {
      options: {
        handler () {
         this.initialize();
        },
        deep: true,
      },
      searchText : function(){
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
			this.initialize();
			}, 600);
		},
    fiscalYear: {
        handler () {
         this.initialize();
        },
        deep: true,
      },
    // QuarterID: {
    //     handler () {
    //      this.initialize();
    //     },
    //   },
    },
    mounted() {
      this.eventHub.$on("closeViewRequest", () => {
        this.initialize();
      });
    },
    beforeDestroy() {
      this.eventHub.$off("closeViewRequest");
    },
    methods: {
      viewItem(data){
        this.viewData = data;
      },
      print(data) {
        window.open(this.apiUrl + "/request/report/" + data.RequestCode);
      },
      cancel() {
        this.editItemId = null;
        this.transferItemId = null;
        this.$refs.formRef.reset();
        this.addBudgetDialog = false;
      },
      initialize () {
        this.loading = true;
        this.loadingCSV = true;
         let data = new FormData();
         if(this.options.page){
              data.append('page', this.options.page);
              data.append('itemsPerPage', this.options.itemsPerPage);
         }else{
              data.append('page', 1);
              data.append('itemsPerPage', 10);
         }
          data.append('searchText', this.searchText);
              this.axiosCall(
              '/request/getCompleted',
              'POST',
              data
          )
          .then((res) => {
            this.loading = false;
            this.loadingCSV = false;
              this.completedList = res.data.data.result;
              this.itemListForCSV = res.data.data.result;
              this.totalCount = res.data.data.total;
              if(this.totalCount <= 10){
                this.options.page = 1;
              }
              if(this.totalCount <= 10){
                this.options.page = 1;
              }
          })
      },
    //   getBudgetTypeAndOffice() {
    //   this.axiosCall(
    //           '/getOfficeAndOthersForCreateUpdate',
    //           'GET'
    //       )
    //       .then((res) => {
    //           this.office = res.data.data.office;
    //           this.fundList = res.data.data.fund;
    //           this.specificfundsourceList = res.data.data.specificfundsource;
    //           this.purposeList = res.data.data.purpose;
    //           this.allotmentList = res.data.data.allotmenttype;
    //           this.deliveryunit = res.data.data.deliveryunit;
    //           this.users = [{UserID: 0, name: 'All'}, ...res.data.data.users];
    //       })
		// },
    changeBudgetMEI(){
      let data = this.formData.BudgetID;
      if(data){
      let details = this.budget.find(b => b.BudgetID === data);
        this.budgetDetails = details;
      }
      else{
        this.budgetDetails = {};
      }
    },
    getBudgetList() {
      this.budget = [];
      let data = new FormData();
      data.append('FiscalYearID', this.fiscalYear);
      this.axiosCall(
              '/getBudgetMAndEList',
              'POST',
              data
          )
          .then((res) => {
              this.budget = res.data.data;
          })
		},
      save () {
         if(this.$refs.formRef.validate() && !this.amountErr){
          this.isLoading = true;
          let data = new FormData();
          data.append('BudgetID', this.formData.BudgetID);
          data.append('PerBudgetRecord', this.formData.PerBudgetRecord);
          data.append('Remarks', this.formData.Remarks);
                      this.axiosCall(
                    '/mei/add',
                    'POST',
                    data
                )
                .then((res) => {
                    this.isLoading = false;
                    if(res.data.status) {
                    this.fadeAwayMessage.show = true;
                    this.fadeAwayMessage.type = 'success';
                    this.fadeAwayMessage.message = 'Budget Successfully Added!';
                    this.fadeAwayMessage.header = 'System Message';
                    this.$refs.formRef.reset();
                    this.addBudgetDialog = false;
                      this.initialize();
                    }else {
                    this.fadeAwayMessage.show = true;
                    this.fadeAwayMessage.type = 'error';
                    this.fadeAwayMessage.message = 'Something went wrong try again!';
                    this.fadeAwayMessage.header = 'System Message';
                    }
                })
         }
      },
      update () {
         if(this.$refs.formRef.validate()){
                     this.isLoading = true;
             let data = new FormData();
              data.append('BudgetID', this.editItemId);
              data.append('FundID', this.formData.FundID);
              data.append('BudgetDate', this.formData.BudgetDate);
              data.append('BudgetDateEnd', this.formData.BudgetDateEnd);
              data.append('PurposeID', this.formData.PurposeID);
              data.append('SpecificFundSourceID', this.formData.SpecificFundSourceID);
              data.append('Amount', this.formData.Amount);
              data.append('OfficeID', this.formData.OfficeID);
              data.append('BudgetCode', this.formData.BudgetCode);
              data.append('AllotmentTypeID', this.formData.AllotmentTypeID);
              data.append('DeliveryUnitID', this.formData.DeliveryUnitID);
              data.append('UserID', this.formData.UserID);
                         this.axiosCall(
                        '/budget/edit',
                        'POST',
                        data
                    )
                    .then((res) => {
                        this.isLoading = false;
                        if(res.data.status) {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'success';
                        this.fadeAwayMessage.message = 'Budget Successfully Updated!';
                        this.fadeAwayMessage.header = 'System Message';
                        this.$refs.formRef.reset();
                        this.addBudgetDialog = false;
                        this.editItemId = null;
                         this.initialize();
                        }else {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'error';
                        this.fadeAwayMessage.message = 'Something went wrong try again!';
                        this.fadeAwayMessage.header = 'System Message';
                        }
                    })
         }
      },
      checkSavings(perBudget, amount) {
        if(perBudget >= amount){
          this.amountErr2 = null;
        }
        else{
          this.amountErr2 = 'Per Budget Record must not exceed Actual Budget/Amount!';
        }
      },
    }
  }
</script>
<style scoped>
.mei-title {
  color: #777 !important;
}
</style>